export enum StakeholderType {
	Individual = 'Individual',
	Team = 'Team'
}

export type Stakeholder = {
	alertMetadataChanges: boolean;
	email: string;
	isLocked: boolean;
	name: string;
	sonarObjectRefCount: number;
	stakeholderId: number;
	stakeholderType: StakeholderType;
	userId?: number;
};
